import React, { useEffect, useMemo, useState } from "react";
import Header from "../../components/Header";
import { useNavigate } from "react-router-dom";
import BottomNavbarZipGame from "../../components/ZipGame/BottomNavbarZipGame";
import classes from "./ZipGameWinners.module.css";
import {
  FaArrowLeft,
  FaCalendarDays,
  FaChevronLeft,
  FaChevronRight,
  FaCrown,
  FaMedal,
  FaTrophy,
  FaStar,
} from "react-icons/fa6";
import { zipGameWinnersApi } from "../../http/http";
import { useSelector } from "react-redux";
import moment from "moment";

const winnersData = {
  "2026-03-19": [
    { id: 1, name: "Rahul", score: 3200, prize: "Gold Badge" },
    { id: 2, name: "Aman", score: 2940, prize: "Silver Badge" },
    { id: 3, name: "Sophia", score: 2810, prize: "Bronze Badge" },
    { id: 4, name: "Daniel", score: 2560, prize: "Top 5 Reward" },
    { id: 5, name: "Neha", score: 2410, prize: "Top 5 Reward" },
    { id: 6, name: "John", score: 2280, prize: "Daily Reward" },
  ],
  "2026-03-18": [
    { id: 1, name: "Maria", score: 3010, prize: "Gold Badge" },
    { id: 2, name: "Rahul", score: 2860, prize: "Silver Badge" },
    { id: 3, name: "Kevin", score: 2705, prize: "Bronze Badge" },
    { id: 4, name: "Elena", score: 2440, prize: "Top 5 Reward" },
    { id: 5, name: "Aman", score: 2325, prize: "Top 5 Reward" },
  ],
  "2026-03-17": [
    { id: 1, name: "Sophia", score: 3140, prize: "Gold Badge" },
    { id: 2, name: "Neha", score: 2875, prize: "Silver Badge" },
    { id: 3, name: "Daniel", score: 2720, prize: "Bronze Badge" },
    { id: 4, name: "Rahul", score: 2490, prize: "Top 5 Reward" },
  ],
};

const ZipGameWinners = () => {
  const navigate = useNavigate();

  const [selectedDate, setSelectedDate] = useState(moment().subtract(1, 'day').format("YYYY-MM-DD"));

  const [winnersList, setWinnersList] = useState([]);

  const [loading, setLoading] = useState(false);

  const { userZip } = useSelector(
    (state) => state?.persisted?.userZipGameTokenSlice
  );

  const getInitials = (name) => {
    if (!name) return "U";
    return name
      .split(" ")
      .map((item) => item[0])
      .join("")
      .slice(0, 2)
      .toUpperCase();
  };

  const maskMsisdn = (value) => {
    const str = String(value || "");
    if (!str) return "Unknown";
    if (str.length <= 2) return str;
    return `****${str.slice(-3)}`;
  };

  const formatDisplayDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  const changeDateByDays = (days) => {
    const current = new Date(selectedDate);
    current.setDate(current.getDate() + days);
    const next = current.toISOString().split("T")[0];
    setSelectedDate(next);
  };

  const fetchWinners = async (date) => {
    try {
      setLoading(true);
      const response = await zipGameWinnersApi(date, userZip?.token);
      console.log(response?.data);
      setWinnersList(response?.data?.result);
      setLoading(false);
    } catch (error) {
      console.log(error, 'erro');
    }
    finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchWinners(selectedDate);
  }, [selectedDate]);

  return (
    <>
      <Header />

      {/* <div className={classes.page}> */}
      <div className={classes.container}>
        <div className={classes.header_section}>
          <button
            className={classes.back_button}
            onClick={() => navigate(-1)}
            type="button"
          >
            <FaArrowLeft className={classes.back_icon} />
          </button>

          <p className={classes.header_title}>Winners</p>
        </div>

        <div className={classes.hero_card}>
          <div className={classes.hero_glow}></div>

          <div className={classes.hero_top}>
            <div className={classes.hero_icon_wrap}>
              <FaTrophy className={classes.hero_icon} />
            </div>

            <div className={classes.hero_texts}>
              <p className={classes.hero_title}>Daily Winners Board</p>
              <p className={classes.hero_subtitle}>
                Select a date to view the top Zip Game winners and rankings.
              </p>
            </div>
          </div>

          <div className={classes.hero_stats}>
            <div className={classes.hero_stat_card}>
              <p className={classes.hero_stat_value}>{winnersList.length}</p>
              <p className={classes.hero_stat_label}>Winners</p>
            </div>

            <div className={classes.hero_stat_card}>
              <p className={classes.hero_stat_value}>{formatDisplayDate(selectedDate)}</p>
              <p className={classes.hero_stat_label}>Selected Date</p>
            </div>
          </div>
        </div>

        <div className={classes.date_selector_card}>
          <div className={classes.section_header}>
            <div className={classes.title_with_icon}>
              <FaCalendarDays className={classes.section_icon} />
              <p className={classes.section_title}>Select Date</p>
            </div>
          </div>

          <div className={classes.date_selector_row}>
            <button
              type="button"
              className={classes.date_nav_btn}
              onClick={() => changeDateByDays(-1)}
            >
              <FaChevronLeft />
            </button>

            <div className={classes.date_input_wrap}>
              <input
                type="date"
                className={classes.date_input}
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
              />
            </div>

            <button
              type="button"
              className={classes.date_nav_btn}
              onClick={() => changeDateByDays(1)}
            >
              <FaChevronRight />
            </button>
          </div>

          <p className={classes.selected_date_text}>
            Showing winners for <span>{formatDisplayDate(selectedDate)}</span>
          </p>
        </div>

        {loading ?

          <div className={classes.state_card}>
            <div className={classes.loader}></div>
            <p className={classes.state_text}>Loading...</p>
          </div>

          : winnersList.length > 0 ? (
            <>
              <div className={classes.section_card}>
                <div className={classes.section_header}>
                  <div className={classes.title_with_icon}>
                    <FaMedal className={classes.section_icon} />
                    <p className={classes.section_title}>All Winners</p>
                  </div>
                </div>

                <div className={classes.winners_list}>
                  {winnersList.map((winner, index) => {
                    const isCurrentUser =
                      String(winner?.msisdn) === String(userZip?.msisdn);
                    return (
                      <div key={winner?.id} className={`${classes.winner_item} ${isCurrentUser ? classes.first_rank : ""}`}>
                        <div className={classes.winner_left}>
                          <div
                            className={`${classes.rank_badge} ${winner.user_rank == 1
                              ? classes.rank_one
                              : winner.user_rank == 2
                                ? classes.rank_two
                                : winner.user_rank === 3
                                  ? classes.rank_three
                                  : classes.rank_default
                              }`}
                          >
                            #{winner.user_rank}
                          </div>

                          {/* <div className={classes.avatar_circle}>
                            {getInitials(winner.name)}
                          </div> */}

                          <div className={classes.avatar_circle}>
                            {winner?.image ? (
                              <img
                                src={winner.image}
                                alt={winner?.name || "User"}
                                className={classes.avatar_image}
                              />
                            ) : (
                              getInitials(winner?.name)
                            )}
                          </div>

                          <div className={classes.player_info}>
                            <p className={classes.player_name}>
                              {winner?.name || "User"}
                            </p>

                            <p className={classes.player_name}>
                              {maskMsisdn(winner?.msisdn)}
                            </p>

                            <p className={classes.player_status}>
                              Moves: {winner?.moves ?? 0}
                              {isCurrentUser ? " • You" : ""}
                            </p>
                          </div>
                        </div>

                        <div className={classes.score_box}>
                          <p className={classes.score_value}>{winner.total_time_seconds}</p>
                          <p className={classes.score_label}>seconds</p>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            </>
          ) : (
            <div className={classes.empty_state}>
              <div className={classes.empty_icon_wrap}>
                <FaCalendarDays className={classes.empty_icon} />
              </div>
              <p className={classes.empty_title}>No winners available</p>
              <p className={classes.empty_text}>
                There are no winners recorded for the selected date. Please choose
                another date.
              </p>
            </div>
          )}
      </div>
      {/* </div> */}

      <BottomNavbarZipGame active={2} />
    </>
  );
};

export default ZipGameWinners;